import React from 'react';
import { colors } from '../../design-system/tokens';

const VARIANT_MAP = {
  success:  { bg: 'bg-[var(--msml-success-bg)]', text: 'text-[var(--msml-success)]', border: 'border-[var(--msml-success)]/20' },
  warning:  { bg: 'bg-[var(--msml-warning-bg)]', text: 'text-[var(--msml-warning)]', border: 'border-[var(--msml-warning)]/20' },
  error:    { bg: 'bg-[var(--msml-danger-bg)]',  text: 'text-[var(--msml-danger)]',  border: 'border-[var(--msml-danger)]/20' },
  info:     { bg: 'bg-[#3B82F6]/10', text: 'text-[#3B82F6]', border: 'border-[#3B82F6]/20' },
  neutral:  { bg: 'bg-white/5', text: 'text-[var(--msml-text-muted)]', border: 'border-white/10' },
};

/**
 * Reusable status badge / pill.
 * variant: 'success' | 'warning' | 'error' | 'info' | 'neutral'
 */
export function StatusBadge({ label, variant = 'neutral', icon, className = '' }) {
  const v = VARIANT_MAP[variant] || VARIANT_MAP.neutral;
  return (
    <span
      className={`inline-flex items-center gap-1 px-1.5 py-0.5 rounded text-[10px] font-medium border ${v.bg} ${v.text} ${v.border} ${className}`}
      data-testid={`badge-${label?.toLowerCase().replace(/\s/g, '-')}`}
    >
      {icon}
      {label}
    </span>
  );
}

/** Maps a verdict string to the correct variant */
export function VerdictBadge({ verdict, className = '' }) {
  const v = (verdict || '').toUpperCase();
  let variant = 'warning';
  if (v === 'APPROVED' || v === 'PASS') variant = 'success';
  else if (v === 'REJECTED' || v === 'FAIL') variant = 'error';
  return <StatusBadge label={verdict} variant={variant} className={className} />;
}

/** Maps a completion status to the correct variant */
export function StatusIndicator({ status, className = '' }) {
  let variant = 'warning';
  if (status === 'completed') variant = 'success';
  else if (status === 'failed') variant = 'error';
  return <StatusBadge label={status} variant={variant} className={className} />;
}
